const SpatialRelation = Object.freeze({
  INTERSECTS: "INTERSECTS",
  CONTAINS: "CONTAINS",
  CROSSES: "CROSSES",
  OVERLAPS: "OVERLAPS",
  TOUCHES: "TOUCHES",
  WITHIN: "WITHIN",
  ENVELOPE_INTERSECTS: "ENVELOPE_INTERSECTS",
  INDEX_INTERSECTS: "INDEX_INTERSECTS",
  DISJOINT: "DISJOINT",
  INTERIOR_INTERSECTS: "INTERIOR_INTERSECTS",
  COINCIDENCE: "COINCIDENCE",
  LINE_TOUCHES: "LINE_TOUCHES",
  POINT_TOUCHES: "POINT_TOUCHES"
});
export default SpatialRelation;